import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const removeAuthorizedAppWidgetAuthorizedApp = createAction(
  `${reduxKey}.REMOVE_AUTHORIZEDAPPS_WIDGET_AUTHORIZED_APP`,
  (deviationId: number) => ({ deviationId })
);

export const removeAuthorizedAppWidgetAuthorizedAppSuccess = createAction(
  `${reduxKey}.REMOVE_AUTHORIZEDAPPS_WIDGET_AUTHORIZED_APP_SUCCESS`,
  (deviationId: number) => ({ deviationId })
);

export const removeAuthorizedAppWidgetAuthorizedAppFailure = createAction(
  `${reduxKey}.REMOVE_AUTHORIZEDAPPS_WIDGET_AUTHORIZED_APP_FAILURE`,
  (deviationId: number, errorMessage: string) => ({ deviationId, errorMessage })
);
